<template>
    <v-container>
        <v-row>
            <v-col><h1>Games</h1></v-col>
        </v-row>

        <v-row v-for="(game, gameIndex) in games" :key="gameIndex">
            <v-col>
                <v-card>
                    <v-card-title>{{ game.title }}</v-card-title>

                    <v-divider/>

                    <v-card-actions>
                        <v-btn text
                               color="primary"
                               @click="$router.push({name: 'game', params: {gameId: game.id}})">
                            Open
                        </v-btn>
                        <v-btn text color="error" @click="deleteGame(game.id)">Delete</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>Create Game</v-card-title>
                    <v-card-text>
                        <v-text-field label="Name" v-model="form.title" @keydown.enter="storeGame"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text color="primary" @click="storeGame">Create</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import GameService from "../services/GameService";

  export default {
    data: () => ({
      loading: false,
      games: [],
      form: {
        title: null
      }
    }),

    created() {
      if (this.$store.state.isUserLoggedIn !== true) {
        this.$router.push({name: 'signin'});
      }

      this.$store.dispatch("setGameId", null);

      this.indexGames();
    },

    methods: {
      indexGames() {
        GameService.index()
          .then(response => {
            this.games = response.data.data;
          });
      },

      storeGame() {
        GameService.store(this.form)
          .then(response => {
            this.$router.push({name: "game-preferences", params: {gameId: response.data.data.id}});
          });
      },

      deleteGame(gameId) {
        if (confirm("Are you sure you want to delete this game?")) {
          GameService.delete(gameId)
            .then(() => {
              this.indexGames();
            });
        }
      }
    }
  };
</script>
